<span *ngIf="!loadingBenchmarks && timePeriod?.value !== 'none'">
  <span class="benchmark" [ngClass]="benchmarkClassName" *ngIf="benchmark; else noBenchmark">
    <i
      [ngClass]="benchmark > 0 ? 'up' : 'down'"
      class="icon caret"
    ></i>
    {{abs(benchmark) | percent:percentOptions}}
  </span>
  <ng-template #noBenchmark>
    <span class="benchmark">n/a</span>
  </ng-template>
</span>
<div *ngIf="timePeriod && timePeriod?.value !== 'none' && loadingBenchmarks" class="ui tiny active inline loader"></div>
